<script>
  import { selNbh } from '../store.js';
  import { colorScale } from '../utils/color.js';
  export let data;
  //   $:console.log(data)
</script>

<div>
  <p class="prose">
    {#if data.latino_percent > 0.5}
      <span class="inline-nbh">{$selNbh}</span> is majority Latino.
    {:else if data.black_percent > 0.5}
      <span class="inline-nbh">{$selNbh}</span> is majority Black.
    {:else if data.white_percent > 0.5}
      <span class="inline-nbh">{$selNbh}</span> is majority white.
    {:else}
      <span class="inline-nbh">{$selNbh}</span> is {Math.round(
        data.latino_percent * 100
      )}% Latino, {Math.round(data.asians_all_percent * 100)}% Asian, {Math.round(
        data.black_percent * 100
      )}% Black and {Math.round(data.white_percent * 100)}% white.
    {/if}

    {#if data.renter_percent > 0.5}
      The majority of households are renters and
    {:else}
      The majority of households are owners and
    {/if}

    {Math.round(data.more_than_60000_pct * 100)}% make more than $60,000.
  </p>

  {#if data.nbh_vote_margin > 0}
    <p class="prose">
      In your neighborhood, Caruso is currently leading by <span
        class="inline-margin"
        style="border-bottom: 2px solid {colorScale(data.nbh_vote_margin)};"
        >{data.nbh_vote_margin < 0.01
          ? Math.round(Math.abs(data.nbh_vote_margin * 10000)) / 100
          : Math.round(Math.abs(data.nbh_vote_margin * 100))} percentage points</span
      >.
    </p>
  {:else if data.nbh_vote_margin < 0}
    <p class="prose">
      In your neighborhood, Bass is currently leading by <span
        class="inline-margin"
        style="border-bottom:2px solid {colorScale(data.nbh_vote_margin)};"
        >{data.nbh_vote_margin < 0.01
          ? Math.round(Math.abs(data.nbh_vote_margin * 10000)) / 100
          : Math.round(Math.abs(data.nbh_vote_margin * 100))} percentage points</span
      >.
    </p>
  {:else}
    <p class="prose">
      In your neighborhood, it's a tie between Bass and Caruso.
    </p>
  {/if}
</div>
